import styled from "@emotion/styled";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";

export const StyledSnackbar = styled(Snackbar)`
  width: 423px;
`;

export const StyledAlert = styled(Alert)`
  width: 100%;
  font-size: 13px;
  font-family: "Inter";
  font-weight: 400;
  line-height: 20px;
`;
